<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g :fill="color" :stroke="color" class="fill-current stroke-current">
      <path
        fill="none"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="10"
        stroke-width="1.3913"
        d="M0.696 16c0-8.452 6.852-15.304 15.304-15.304s15.304 6.852 15.304 15.304c0 8.452-6.852 15.304-15.304 15.304s-15.304-6.852-15.304-15.304z"
      />
      <path
        fill="none"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="10"
        stroke-width="1.3913"
        d="M9.043 16l11.965 7.652c-0.839-2.272-1.345-4.896-1.391-7.632l-0-0.021c0.215-2.813 0.709-5.419 1.459-7.915l-0.068 0.262z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
